module.exports = __webpack_public_path__ + "img/wood2.7b852218.png";